import React from "react";
import { User } from "@/api/users";
import {
  MultipleSelectDataGrid,
  DataGridColumn,
} from "@/ui-controls/DataGrid";
interface Props {
  UserList: User[];
  onSelectionChanged: (selectedList: User[]) => any;
}

const UserSelectDetailList = (props: Props) => {
  const columns: DataGridColumn[] = [
    {
      key: "emailAddress",
      name: "EmailAddress",
      fieldName: "EmailAddress",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
  ];

  return (
    <>
      <MultipleSelectDataGrid
        items={props.UserList}
        columns={columns}
        onSelectionChanged={props.onSelectionChanged}
      />
    </>
  );
};

export default UserSelectDetailList;
